import { animate, state, style, transition, trigger } from '@angular/animations';

const iconRotate = trigger('iconRotate', [
  state('normal', style({ transform: 'rotate(0deg)' })),
  state('hover', style({ transform: 'rotate(60deg)' })),
  transition('normal <=> hover', animate('200ms ease')),
]);

export { iconRotate };
